export default __webpack_public_path__ + "static/media/PowerBI_Example_1.a1225c5f.png";